import { DomSmallUtils } from 'sharedGuiSmall/utils/dom-utils';

declare var jQuery: JQueryStatic;
declare function saveAs(data: Blob, fileName: string): void;

interface SetAreaLoadingOptions {
    areaEl: Element;
    loading: boolean;
    xOffset?: number;
    yOffset?: number;
    testId?: string;
    spinnerId?: string;
    zIndex?: number;
}

export class Utils {
   
    public static getNavigatorLanguage(): string {
        return (navigator.languages && navigator.languages.length) ? navigator.languages[0] : navigator.language || 'en';
    }

    public static decodeHTML(html: string) {
        var txt = document.createElement('textarea');
        txt.innerHTML = html;
        return txt.value;
    }

    public static isValue(value: any): boolean {

        return typeof (value) != "undefined" && value != null;

    }

    public static isNumeric(value: any): boolean {

        return !isNaN(parseFloat(value)) && isFinite(value);

    }

    public static isEmpty(value: string): boolean {

        // TODO remove IF after strict checks
        if (typeof value !== 'string') {
            value = '' + value;
        }

        return (value.length === 0 || !value.trim());

    }

    public static isNullOrEmpty(value: any): boolean {
        return value === null || value === undefined || value === '';
    }

    public static isAnyNullOrEmpty(...values: any[]): boolean {
        return values?.some(x => this.isNullOrEmpty(x)) ?? true;
    }

    public static getQueryParam(url: string, key: string): string  {
        var queryStartPos = url.indexOf('?');
        if (queryStartPos === -1) {
            return '';
        }
        var params = url.substring(queryStartPos + 1).split('&');
        for (var i = 0; i < params.length; i++) {
            var pairs = params[i].split('=');
            if (decodeURIComponent(pairs.shift()!) == key) {
                return decodeURIComponent(pairs.join('='));
            }
        }

        return '';
    }


    private static foundZIndex: number = 0;

    public static getZIndex(el: Node): number {

        const util = this;

        const limitObj = document ? document.body : document;
        if (!el || el == limitObj) {
            const z = util.foundZIndex;

            util.foundZIndex = 0;
            return z;
        }

        let index: number = 0;
        try {
            let zToParse = getComputedStyle(el as Element).getPropertyValue("z-index");

            const htmlEl = el as HTMLElement;
            if (htmlEl['style'] && htmlEl['style'].zIndex)
                zToParse = htmlEl['style'].zIndex;

            index = parseInt(zToParse);
        }
        catch (ex) {}

        if (!isNaN(index)) {

            util.foundZIndex = index;

        }

        return el.parentNode ? util.getZIndex(el.parentNode) : index;

    }


    public static stringToDate(planString: string) {

        var d = planString.split('/');
        if (d[3]) {
            var t = d[3].split(':');
            return new Date(parseInt(d[2]), parseInt(d[1]) - 1, parseInt(d[0]), parseInt(t[0]), parseInt(t[1]), parseInt(t[2]));
        }
        return new Date(parseInt(d[2]), parseInt(d[1]) - 1, parseInt(d[0]));

    }

    /*Color Utils*/

    public static isHexColor(color: string) {

        return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(color);

    }

    public static roundToTwo(num: number): number {

        return +(Utils.fromExponential(Math.round(parseFloat(Utils.fromExponential(num) + "e+2"))) + "e-2");

    }

    public static roundToEight(num: number): number {

        return +(Utils.fromExponential(Math.round(parseFloat(Utils.fromExponential(num) + "e+8"))) + "e-8");
    }


    public static getNgContentAttrName(dom: HTMLElement): string | null {
        let ngAttr = null;

        jQuery.each(dom.attributes, function (_index: number, value: Attr) {
            if (value.specified && value.name.indexOf('_ngcontent') != -1) ngAttr = value.name;
        });

        return ngAttr;
    }

    // Check if child node has parent node with this tag name
    public static hasParentNode(child: Node, parentNodeName: string): boolean {
        let node: Node | null = child;

        parentNodeName = parentNodeName.toUpperCase();

        while (node) {
            if (node.nodeName === parentNodeName) {
                return true;
            }

            node = node.parentNode;
        }

        return false;
    }

    // Check if any parent node has this class
    public static parentHasClass(child: HTMLElement, className: string): boolean {
        let node: HTMLElement | null = child;

        while (node) {
            if (node.classList.contains(className)) {
                return true;
            }

            node = node.parentElement;
        }

        return false;
    }

    public static getButtons(event: MouseEvent) {

        if (!event) return 0;

        let buttons = event.buttons !== undefined ? event.buttons : event.which === 0 ? 0 : 1 << (event.which - 1);

        return buttons;

    }


    public static getCookie(name: string): string {

        const matches = document.cookie.match(new RegExp(
            "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
        ));
        return matches ? decodeURIComponent(matches[1]) : '';

    }

    public static formatNumberByLangSettings(num: string): string {
        if (!num) return '0';

        let result: string = num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + Utils.thousandSeparator);

        // Remove commas in decimals (1,000.12,345 -> 1,000.12345)
        const ind = result.indexOf('.');
        if (ind !== -1) {
            result = result.substring(0, ind) + Utils.decimalSeparator + result.substring(ind + 1).replace(new RegExp(',', 'g'), '');
        }

        return result;
    }

    // This way depends on browser language not system locale
    public static get thousandSeparator(): string {
        return (1111).toLocaleString().replace(/1/g, '');
    }

    public static get decimalSeparator(): string {
        return (1.1).toLocaleString().replace(/1/g, '');
    }

    public static GTMRecordUrlChange(url: string): void {
        if (window['dataLayer'])
            window['dataLayer'].push({
                'event': 'Pageview',
                'url': url
            });
    }

    public static GTMRecordTestidClick(testid: string): void {
        if (window['dataLayer'])
            window['dataLayer'].push({
                'event': 'TestidElClick',
                'testid': testid
            });
    }

    private static getExponentialParts(num: number | string | Array<any>): Array<string> {
        return Array.isArray(num) ? num : String(num).split(/[eE]/);
    }

    private static isExponential(num: number | string | Array<any>): boolean {
        const eParts = Utils.getExponentialParts(num);
        return !Number.isNaN(Number(eParts[1]));
    }

    // Converts exponential notation to a human readable string
    public static fromExponential(num: number | string | Array<any>): string {
        const eParts = Utils.getExponentialParts(num);
        if (!Utils.isExponential(eParts)) {
            return eParts[0];
        }

        const sign = eParts[0][0] === '-' ? '-' : '';
        const digits = eParts[0].replace(/^-/, '');
        const digitsParts = digits.split('.');
        const wholeDigits = digitsParts[0];
        const fractionDigits = digitsParts[1] || '';
        let e = Number(eParts[1]);

        if (e === 0) {
            return `${sign + wholeDigits}.${fractionDigits}`;
        } else if (e < 0) {
            // move dot to the left
            const countWholeAfterTransform = wholeDigits.length + e;
            if (countWholeAfterTransform > 0) {
                // transform whole to fraction
                const wholeDigitsAfterTransform = wholeDigits.substr(0, countWholeAfterTransform);
                const wholeDigitsTransformedToFracton = wholeDigits.substr(countWholeAfterTransform);
                return `${sign + wholeDigitsAfterTransform}.${wholeDigitsTransformedToFracton}${fractionDigits}`;
            } else {
                // not enough whole digits: prepend with fractional zeros

                // first e goes to dotted zero
                let zeros = '0.';
                e += 1;
                while (e) {
                    zeros += '0';
                    e += 1;
                }
                return sign + zeros + wholeDigits + fractionDigits;
            }
        } else {
            // move dot to the right
            const countFractionAfterTransform = fractionDigits.length - e;
            if (countFractionAfterTransform > 0) {
                // transform fraction to whole
                // countTransformedFractionToWhole = e
                const fractionDigitsAfterTransform = fractionDigits.substr(e);
                const fractionDigitsTransformedToWhole = fractionDigits.substr(0, e);
                return `${sign + wholeDigits + fractionDigitsTransformedToWhole}.${fractionDigitsAfterTransform}`;
            } else {
                // not enough fractions: append whole zeros
                let zerosCount = -countFractionAfterTransform;
                let zeros = '';
                while (zerosCount) {
                    zeros += '0';
                    zerosCount -= 1;
                }
                return sign + wholeDigits + fractionDigits + zeros;
            }
        }
    }


    public static isScrolledHorizontally(div: HTMLElement) {

        const scrollSize = parseInt(div.scrollWidth + '');
        const viewportSize = Math.ceil(DomSmallUtils.outerWidthFull(div));

        if (scrollSize <= viewportSize) return false;
        else return true;
    }

    public static isScrolledVertically(div: HTMLElement) {

        const scrollSize = parseInt(div.scrollHeight + '');
        const viewportSize = Math.ceil(DomSmallUtils.outerHeightFull(div));

        if (scrollSize <= viewportSize) return false;
        else return true;
    }

    // Set new ConversationId if needed
    public static checkConversationId(): void {
        // If ConversationId is empty or we have gone from login page
        if (!window.localStorage.getItem('ConversationId')) {
            this.setConversationId();
        }

        // Remove old ActivityId from cookie, it was renamed to ConversationId
        document.cookie = `ActivityId=; path=/; expires=${new Date(0).toUTCString()}`;
    }

    // Set new ConversationId
    public static setConversationId(): void {
        // Add to localStorage
        window.localStorage.setItem('ConversationId', window['nextConversationId']);

        // Add to cookie
        var expire = new Date();
        expire.setFullYear(expire.getFullYear() + 100);

        document.cookie = `ConversationId=${window['nextConversationId']}; path=/; expires=${expire.toUTCString()}`;
    }

    // Clear stored ConversationId (used in logging)
    public static clearConversationId(): void {
        // Remove from localStorage
        window.localStorage.removeItem('ConversationId');

        // Remove from cookie
        document.cookie = `ConversationId=; path=/; expires=${new Date(0).toUTCString()}`;
    }

    public static downloadFile(url: string, data: any, successCallback: Function, failCallback: Function): void {
        var xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function () {
            if (this.readyState === 4) {
                if (this.status == 200) {
                    if (this.response) {
                        var res = this.response;

                        var fileName = this.getResponseHeader('X-File-Name');
                        var data = new Blob([res]);
                        if (fileName) {
                            saveAs(data, fileName);
                            if (successCallback) successCallback();
                        }
                        else
                        {
                            console.error('downloadFile: fileName is undefined');
                            if (failCallback) failCallback();
                        }
                    }
                }
                else {
                    if (failCallback) failCallback();
                }
            }
        }
        xhr.open('POST', url);
        xhr.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem("accessToken"));
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.responseType = 'arraybuffer';
        xhr.send(JSON.stringify(data));
    }

    public static readonly zIndexSelector = ":not(#tblReportBody *, #hubspot-messages-iframe-container, #hubspot-conversations-iframe, div[id^='hs-']):visible";

    static dec2hex(dec: number) {
        return dec.toString(16).padStart(2, "0")
    }

    static generateId(len: number) {
        var arr = new Uint8Array((len || 40) / 2)
        window.crypto.getRandomValues(arr)
        return Array.from(arr, this.dec2hex).join('')
    }
}
